import script from "./subject.vue?vue&type=script&setup=true&lang=js"
export * from "./subject.vue?vue&type=script&setup=true&lang=js"

import "./subject.vue?vue&type=style&index=0&id=c7b03886&lang=scss&scoped=true"

import exportComponent from "/var/www/ddup_czb/slczb_app_web/view/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c7b03886"]])

export default __exports__